import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import EpicCoverage from '../components/EpicCoverage/EpicCoverage'
import PlanSection from '../components/PlanSection'
import withApp from '../components/withApp/withApp'
import TrustPilot from '../components/TrustPilot'
import FeaturedIn from '../components/FeaturedIn'
import SEO from '../components/Seo'

// Global Styled Components
import { Title, Heading, Paragraph } from '../components/styles/Text'
import { TwoColumn } from '../components/styles/Columns'
import SiteContainer from '../components/styles/SiteContainer'
import Spacer from '../components/styles/Spacer'
import Icon from '../components/styles/Icon'
import FaqSection, { defaultFaqList } from '../modular-system/FaqSection'

// IMAGES & CONTENT
import HeaderImage from '../static/images/simBubble.svg'
import { RICH_DATA_STRINGS } from '../constants/globalStrings'

const StudentSim = ({ plans: { plans } }) => (
  <React.Fragment>
    <SEO
      title="Starting college? We've got the best student sim only deals (2019 Winnner)"
      description="A no hassle, kind-of-a SIM only student discount deal. Something that's straightforward, simple and honest."
      itemType={RICH_DATA_STRINGS.FAQ_ITEM_TYPE}
    />
    <SiteContainer>
      <Spacer />
      <TwoColumn style={{ alignItems: 'center', textAlign: 'left' }}>
        <div>
          <Title marginBottom="16px">
            Starting college? We&apos;ve got the student SIM plan for you.
          </Title>
        </div>
        <div>
          <Icon src={HeaderImage} alt="" width="100%" />
        </div>
      </TwoColumn>
      <Paragraph margin="0 0 6px 0">
        First things first, you need a good deal, right? A no hassle, kind-of-a
        SIM only student discount deal. Something that’s straightforward, simple
        and honest.
      </Paragraph>
      <Paragraph margin="0 0 6px 0">
        How does great data, no tie-in or minimum contract, no credit checks,
        and no surprises at the end of the month sound?
      </Paragraph>
      <Paragraph margin="0 0 6px 0">
        Join us and find out. We’re the network that’s given back over £1m in
        discounts to customers.
      </Paragraph>
      <Paragraph margin="0 0 6px 0">Live a bit SMARTY.</Paragraph>
      <Spacer />
      <div
        data-module-id={plans.length > 0 ? 'plan-modules-student-sim' : null}
        data-module_name="simple-plans"
        data-module_placement="products-section"
      >
        <PlanSection plans={plans} />
      </div>
      <Spacer />
      <Heading>Some SMARTY saving stats.</Heading>
      <Paragraph margin="16px 0">
        We’re the only UK network that gives you a discount every month for any
        unused data. We automatically take it off your next month’s bill –
        simple.
      </Paragraph>
      <Paragraph margin="0 0 16px">
        We don’t do lock-ins. After a month you can choose to stay or go,
        whenever you want.
      </Paragraph>
      <Paragraph margin="0 0 16px">
        UK calls and texts are unlimited on all plans.
      </Paragraph>
      <Paragraph margin="0 0 16px">
        We’re the highest rated UK network on Trustpilot. Check out our latest
        reviews{' '}
        <a
          href="https://uk.trustpilot.com/review/smarty.co.uk"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        .
      </Paragraph>
      <Paragraph margin="0 0 16px">
        For total peace of mind we have a new{' '}
        <Link to="/unlimited-sim">Unlimited plan</Link> – £20 a month, no
        restrictions, no throttling – truly limitless.
      </Paragraph>
      <Paragraph margin="0 0 16px">
        Our plans all include tethering, so you can use SMARTY in your phone and
        tablet to stream, download and research to your heart’s content.
      </Paragraph>
      <Paragraph margin="0 0 16px">
        See what we mean? There are student SIM only deals and{' '}
        <Link to="/sim-only">‘student SIM only deals’</Link>. SMARTY gives you
        freedom and great value. <Link to="/">Sign up today</Link>.
      </Paragraph>
      <TrustPilot dataTags="SelectedReview" />
      <FaqSection faqAccordions={defaultFaqList} />
      <Spacer />
      <EpicCoverage title="Powered by Three" dark />
      <Spacer />
      <FeaturedIn />
    </SiteContainer>
  </React.Fragment>
)

StudentSim.propTypes = {
  plans: {
    plans: PropTypes.array.isRequired,
  },
}

export default withApp(StudentSim)
